import { FaBitcoin } from 'react-icons/fa'
import CryptoTicker from '../CryptoTicker'

const Bitcoin = (): JSX.Element => (
  <CryptoTicker
    coinId="bitcoin"
    title="Bitcoin"
    subtitle="The Hardest Money"
    icon={FaBitcoin}
  />
)

export default Bitcoin
